// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1I53C","file":"styles_file__6FwHs"};